// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "init_colorPicker", inline: true };
const loggerMsgs = {
  initStart: ["init. colorPicker"],
  initSuccess: ["init. colorPicker", "init. success"],
  noValidDOMEl: ["init. colorPicker", "no valid DOM element provided"],
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_colorPicker() {
  // Setup...
  const { colorPicker, tooltip_colorPicker } = this.ref;
  this.logger("init", loggerMsgs.initStart, "action", logArgs);

  // Guard...
  if (!this.validate_refEl(colorPicker)) return this.cancel_featInit(loggerMsgs.noValidDOMEl);

  // Set Coloris instance...
  Coloris.setInstance(".coulage-color-input", {
    theme: "polaroid",
    alpha: false,
    onChange: (COLOR) => this.setState({ selectedColor: COLOR }),
  });

  // Set init. color on clr-field el...
  const colorisField = colorPicker.querySelector(".clr-field");
  if (this.validate_refEl(colorisField)) colorisField.style.color = "#000";

  // Set init. selected color state...
  this.setState({ mode: "init" });
  this.setState({ selectedColor: "#000" });
  this.setState({ mode: "ready" });

  // Init. tooltip...
  this.init_tooltip(colorPicker, tooltip_colorPicker);

  // Conclude...
  this.logger("init", loggerMsgs.initSuccess, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
